import React, { useCallback } from 'react';

import { useAppDispatch } from 'shared/lib';
import type { TFormAnalyticsEventsOverrides } from 'shared/types/TFormAnalyticsEventsOverrides';

import { useSendFirstTouch } from 'features/SendLoansFirstTouch';

import { updateUserLandingDataThunk, Form } from '../LandingInfo';

export type TAnketaProps = {
  isLoading?: boolean;
  onFormComplete?: () => void;
  analyticsOverrides?: TFormAnalyticsEventsOverrides;
};

export const VitrinsAnketa: FC<TAnketaProps> = (props) => {
  const { isLoading, onFormComplete, analyticsOverrides } = props;
  const dispatch = useAppDispatch();
  const sendFirstTouch = useSendFirstTouch();

  const onFormSubmit = useCallback(
    async (_: unknown) => {
      await dispatch(updateUserLandingDataThunk());
      onFormComplete?.();
    },
    [dispatch, onFormComplete],
  );

  return (
    <Form
      onFormSubmit={onFormSubmit}
      isLoading={isLoading}
      onAuthorizationSuccess={sendFirstTouch}
      analyticsOverrides={analyticsOverrides}
    />
  );
};
